import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { TerminateLineInterface } from '../../../models/terminate-line.interface';
import { SaveMission } from '../../../store/actions/mission.actions';
import { LineInterface } from '../../../../lines/models/line.interface';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import moment from 'moment';
import { LandLineListInterface } from '../../../../landlines/models/land-line-list.interface';
import { SaveLandlineMission } from '../../../store/actions/landline-mission.actions';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'app-terminate-line',
    templateUrl: './terminate-line.component.html',
    styleUrls: ['./terminate-line.component.css'],
    standalone: false
})
export class TerminateLineComponent implements OnInit {
    constructor(
        private store: Store<any>,
        private domSanitizer: DomSanitizer,
        private matIconRegistry: MatIconRegistry,
    ) {}

    @Input()
    line: LineInterface|null;

    @Input()
    landLine: LandLineListInterface|null;

    @Input()
    dateChange: EventEmitter<MatDatepickerInputEvent<Date>>;

    @Input()
    procedureCode: string;

    formSubmitted: boolean;
    displayError: boolean;
    displayConfirmation: boolean;
    portability: boolean;
    date: Date;
    minDate: string;
    maxDate: string;
    triedValidate: boolean;
    validDates: Date[];
    firstValidDate: FormControl;
    step: number;
    brand?: string;

    ngOnInit() {
        this.brand = environment.data.brand;
        this.step = 1;
        this.formSubmitted = false;
        this.triedValidate = false;
        this.displayConfirmation = false;
        this.portability = false;
        this.displayError = false;
        this.date = null;
        let minDate = new Date();
        let daysNumber = 10;
        if (this.line && this.line.statusDetails.portabilityDate !== null) {
            const portabilityDate = this.line.statusDetails.portabilityDate.replace(' 00:00:00', '');
            const portabilityDateAsArray = portabilityDate.split('/');
            if (portabilityDateAsArray.length === 3) {
                const formattedDate = portabilityDateAsArray[2] + '-' + portabilityDateAsArray[1] + '-' + portabilityDateAsArray[0];
                if (moment() < moment(formattedDate)) {
                    minDate = new Date(portabilityDateAsArray[2] + '-' + portabilityDateAsArray[1] + '-' + portabilityDateAsArray[0]);
                    daysNumber = 1;
                }
            }
        }
        const maxDate = new Date();
        minDate.setDate(minDate.getDate() + daysNumber);
        maxDate.setDate(minDate.getDate() + 180);
        const minMonth = (minDate.getMonth() + 1) < 10 ? '0' + (minDate.getMonth() + 1) : (minDate.getMonth() + 1);
        const maxMonth = (maxDate.getMonth() + 1) < 10 ? '0' + (maxDate.getMonth() + 1) : (maxDate.getMonth() + 1);
        const minDay = minDate.getDate() < 10 ? '0' + minDate.getDate() : minDate.getDate();
        const maxDay = maxDate.getDate() < 10 ? '0' + maxDate.getDate() : maxDate.getDate();
        this.minDate = minDate.getFullYear() + '-' + minMonth + '-' + minDay;
        this.maxDate = maxDate.getFullYear() + '-' + maxMonth + '-' + maxDay;
        this.matIconRegistry.addSvgIcon(
            'agenda',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
              '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
            )
        );
        this.validDates = [];
        for (let i = 0; i < 180; i++) {
            const result = new Date(minDate);
            result.setDate(result.getDate() + i);
            result.setHours(0, 0, 0, 0);
            this.validDates.push(result);
        }
        this.firstValidDate = new FormControl(this.validDates[0]);
        this.date = this.validDates[0];
    }

    /**
     * Date range filter
     * @param forDay Date iteration
     */
    dateRangeFilter = (forDay: Date | null): boolean => {
        return this.validDates.some(
            (date) => date.toDateString() === forDay.toDateString()
        );
    }

    /**
     * @param value Value of portability
     */
    changePortability(value: boolean) {
        this.portability = value;
        if (value === false) {
            this.date = this.validDates[0];
        } else {
            this.date = null;
        }
    }

    /**
     * Sets the selected if date if picked in the picker.
     * @param event Date
     */
    setSelectedDate(event) {
        if (event != null) {
            this.date = event;
        }
    }

    /**
     * Handles manual input of date
     * @param date Date
     */
    handleManualInput(date: string) {
        this.date = moment(date, 'DD/MM/YYYY').toDate();
    }


    /**
     * Checks validity of date 10 to 60 days.
     * @param date Date
     */
    checkValidDate(date: Date): boolean {
        if (date === null) {
            return false;
        }

        return this.validDates.some((d) =>
            date.getTime() === new Date(d).getTime()
        );
    }

    /**
     * Save data
     */
    save() {
        this.triedValidate = true;
        if ( this.checkValidDate(this.date)) {
            this.displayConfirmation = true;
            this.step = 2;
        } else {
            this.displayError = true;
        }
    }

    /**
     * Confirmation of the execution of the procedure.
     * Calls procedure.
     */
    confirmation() {
        this.displayError = false;
        if (this.formSubmitted === false) {
            this.formSubmitted = true;
            if (this.concernsLandLine()) {
                this.store.dispatch(
                    new SaveLandlineMission(
                        {
                            step: 1,
                            portability: this.portability,
                            date: moment(this.date).format('YYYY-MM-DD'),
                            landline: this.landLine.phoneNumber
                        },
                        this.procedureCode
                    )
                );
            } else {
                const terminateLineInterface = {
                    phoneNumber: this.getPhoneNumber(),
                    step: 1,
                    portability: this.portability,
                    date: moment(this.date).format('YYYY-MM-DD'),
                } as TerminateLineInterface;
                this.store.dispatch(new SaveMission(terminateLineInterface, this.procedureCode));
            }
        }
    }

    cancel() {
        this.store.dispatch(new UpdateSelectedProcedure(''));
    }

    getPhoneNumber(): string {
        return this.concernsLandLine() ? this.landLine.phoneNumber : this.line.phoneNumber;
    }

    concernsLandLine(): boolean {
        return (this.landLine && !this.line);
    }

    numberFormat(text: any) {
        if (['', null, 0, undefined].indexOf(text) !== -1) {
            return 0;
        } else if (text.toString().includes('.')) {
            return parseFloat(text.toString());
        } else {
            return parseInt(text.toString(), 10);
        }
    }

    dateFormat(date: string) {
        return moment(date).format('DD/MM/YYYY');
    }

    diffBetweenTwoDates() {
        return moment(this.line.endCommitmentDate).diff(moment(), 'months');
    }

    lastBillDate(portability: boolean, date: Date|null) {
        if (!portability) {
            const day = parseInt(moment(date).format('DD'), 10);
            const lastBillDay = this.line.billingCycleDay < 10 ? '0' + this.line.billingCycleDay : this.line.billingCycleDay;
            const lastBillDate = lastBillDay + '/' + moment(date).format('MM/YYYY');
            if (day < this.line.billingCycleDay) {
                return lastBillDate;
            } else {
                return moment(lastBillDate, 'DD/MM/YYYY').add(1, 'months').format('DD/MM/YYYY');
            }
        } else {
            const lastBillDay = this.line.billingCycleDay < 10 ? '0' + this.line.billingCycleDay : this.line.billingCycleDay;
            const lastBillDate = lastBillDay + '/' + moment().format('MM/YYYY');
            if (parseInt(moment().format('DD'), 10) < this.line.billingCycleDay) {
                return lastBillDate;
            } else {
                return moment(lastBillDate, 'DD/MM/YYYY').add('1', 'months').format('DD/MM/YYYY');
            }
        }
    }
}
